export type UserType =
    | {
          type: 'accountId';
          accountId: string;
      }
    | {
          type: 'profileId';
          profileId: string;
      };

export function userToQuery(user: UserType) {
    switch (user.type) {
        case 'accountId':
            return { accountId: user.accountId };
        case 'profileId':
            return { profileId: user.profileId };
    }
}

export function getUserId(user: UserType) {
    switch (user.type) {
        case 'accountId':
            return user.accountId;
        case 'profileId':
            return user.profileId;
    }
}
